import { VoiceClient } from 'modules/ai_voice/components/VoiceClient'
import { useVoiceSession } from 'modules/ai_voice/providers/voiceSession'

export function VoiceModeRenderer() {
  const { params } = useVoiceSession()

  return <VoiceClient agent={params.agent} task={params.task} />
}
